import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const basePath = "/api/dog/pripusti/pripustSamice";

const unwrap = (data) =>
  data && typeof data === "object" && data.output ? data.output : data;

export const findPripustSamiceByKey = createAsyncThunk(
  "pripustSamice/findByKey",
  async ({ key, page, filter, sort }, thunkAPI) => {
    try {
      const response = await ApiClient.get(
        `${basePath}/page`,
        {},
        page,
        filter,
        sort,
        true
      );
      return { key, page: response.data };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err);
    }
  }
);

export const createPripustSamica = createAsyncThunk(
  "pripustSamice/create",
  async (dto, thunkAPI) => {
    try {
      const response = await ApiClient.post(basePath, dto);
      return unwrap(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err);
    }
  }
);

export const deletePripustSamica = createAsyncThunk(
  "pripustSamice/delete",
  async ({ id, version }, thunkAPI) => {
    try {
      const response = await ApiClient.delete(
        `${basePath}/${id}?version=${encodeURIComponent(version)}`
      );

      return { id, deleted: response.data };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err);
    }
  }
);

export const fetchFemaleMatingLogsPage = createAsyncThunk(
  "pripustSamice/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${basePath}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const matingLogFemaleSlice = createSlice({
  name: "pripustSamice",
  initialState: {
    pageByKey: {},
    isLoadingByKey: {},
    errorByKey: {},
    page: null,
  },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(findPripustSamiceByKey.pending, (s, a) => {
      s.isLoadingByKey[a.meta.arg.key] = true;
      s.errorByKey[a.meta.arg.key] = null;
    });
    b.addCase(findPripustSamiceByKey.fulfilled, (s, a) => {
      const { key, page } = a.payload;
      s.pageByKey[key] = page;
      s.isLoadingByKey[key] = false;
    });
    b.addCase(findPripustSamiceByKey.rejected, (s, a) => {
      const key = a.meta.arg?.key;
      if (key) s.isLoadingByKey[key] = false;
      if (key) s.errorByKey[key] = a.payload || a.error;
    });
    b.addCase(fetchFemaleMatingLogsPage.fulfilled, (state, action) => {
      state.isLoading = false;
      state.page = action.payload;
    });
    b.addCase(fetchFemaleMatingLogsPage.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
    b.addCase(fetchFemaleMatingLogsPage.pending, (state, _action) => {
      state.isLoading = true;
      state.error = null;
    });
  },
});

export default matingLogFemaleSlice.reducer;
